import * as Blog from "./Esg-guide-blog-styles";
import BlogList from "./Esg-guide-blog-list";
import { useRouter } from "next/router";
import { Spinner } from "react-bootstrap";
import { useBoardListQuery } from "@hook/esg-guide/useBoardListQuery";
import NoticePagination from "@components/csboard/notice/notice-pagination";

const EsgGuideBlog = ({
  blogMenu,
  searchParams,
  page,
  pageRows,
  onPageChange,
}) => {
  // boardName 결정
  const boardName = blogMenu === 0 ? "package" : "make";
  const adjustedPageRows =
    boardName === "package" || boardName === "make" ? 12 : pageRows || 12;

  // 데이터 가져오기
  const {
    data: blogData = { items: [], totalCount: 0, totalPages: 0 },
    isLoading: blogLoading,
    error,
  } = useBoardListQuery({
    boardName: boardName,
    keyword: searchParams?.searchTerm || "",
    page: page || 1,
    pageRow: adjustedPageRows,
  });

  // 구조 분해 할당으로 데이터 추출
  const { items: blogList, totalCount, totalPages } = blogData;

  // 페이지네이션 그룹 계산
  const getPaginationGroup = () => {
    let start = Math.floor(((page || 1) - 1) / 5) * 5;
    return new Array(Math.min(5, totalPages - start))
      .fill()
      .map((_, idx) => start + idx + 1);
  };

  // 사용자 정의 handleActive 함수 - 페이지 변경 처리도 함께 수행
  const customHandleActive = (pageNumber) => {
    const activeClass = (page || 1) === pageNumber ? "active" : "";
    // 페이지 변경 호출
    onPageChange(pageNumber);
    return activeClass;
  };

  return (
    <>
      {blogLoading && (
        <div>
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "500px" }}
          >
            <Spinner animation="border" role="status" />
          </div>
        </div>
      )}
      <Blog.Container>
        <div className="col-lg-12">
          <Blog.GridList>
            {blogList && blogList.length > 0 ? (
              <BlogList blogList={blogList} />
            ) : (
              !blogLoading && (
                <div
                  className="text-center py-5"
                  style={{ gridColumn: "1 / -1" }}
                >
                  <p>검색 결과가 없습니다.</p>
                </div>
              )
            )}
          </Blog.GridList>

          {/* 페이지네이션을 그리드 레이아웃 밖으로 이동 */}
          {blogList && blogList.length > 0 && (
            <div className="w-100 d-flex justify-content-center mt-30 mb-30">
              <div className="d-flex align-items-center">
                <NoticePagination
                  prev={() => onPageChange((page || 1) - 1)}
                  currentPage={page || 1}
                  getPaginationGroup={getPaginationGroup()}
                  next={() => onPageChange((page || 1) + 1)}
                  pages={totalPages}
                  nextEnd={() => onPageChange(totalPages)}
                  prevStart={() => onPageChange(1)}
                  handleActive={customHandleActive}
                />
                <div className="d-none d-md-flex align-items-center ml-10">
                  {page || 1} / {totalPages}
                </div>
              </div>
            </div>
          )}
        </div>
      </Blog.Container>
    </>
  );
};

export default EsgGuideBlog;
